<template>
  <div class="area">
    <div v-if="!loading && data.length" id="chartdiv" ref="chartdiv" />
  </div>
</template>

<script lang="ts">
import {
  ref,
  shallowRef,
  onMounted,
  onBeforeUnmount,
  defineComponent
} from 'vue'

import { am4core, am4charts } from '@/utils/async_chart_loader'

export default defineComponent({
  name: 'BarChart',
  props: {
    data: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  setup(props, context) {
    const chartdiv = ref(null)
    const chartBox = shallowRef()

    const renderChart = () => {
      clearChart()
      // @ts-ignore: Object is possibly 'null'.
      const chart = am4core.create(chartdiv.value, am4charts.XYChart)

      // Add data
      chart.data = props.data

      // Create axes
      const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = 'id'
      categoryAxis.renderer.minGridDistance = 10
      categoryAxis.renderer.labels.template.rotation = 20
      categoryAxis.title.text = 'Browsers'

      const valueAxis = chart.yAxes.push(new am4charts.ValueAxis())
      valueAxis.title.text = 'Imps'

      // Create series
      const series = chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.valueY = 'value'
      series.dataFields.categoryX = 'id'
      series.columns.template.tooltipText =
        'Category: {categoryX}\nmodelValue: {valueY}'
      series.columns.template.fill = am4core.color(chart.colors.getIndex(1).hex)

      // Add cursor
      chart.cursor = new am4charts.XYCursor()

      chartBox.value = chart
    }

    const clearChart = () => {
      if (chartBox.value && !chartBox.value.isDisposed) {
        chartBox.value.dispose()
        chartBox.value = null
      }
    }

    onMounted(() => {
      renderChart()
    })

    onBeforeUnmount(() => {
      clearChart()
    })

    return { chartdiv }
  }
})
</script>

<style lang="scss" scoped>
.area {
  height: 400px !important;
  position: relative;
  .main-chart {
    background: #fff;
    height: 100%;
  }
  .el-radio-group {
    margin: 10px 0;
  }
  .center {
    position: absolute;
    margin: 0;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }
}
#chartdiv {
  width: 100%;
  height: 100%;
}
</style>
